import {
  LS_API_BASE,
  readApiBase as readApiBaseShared,
  type ReadApiBaseOptions,
  readAppOrigin as readAppOriginShared} from '@glyphic/shared-core'

export { LS_API_BASE }

function webApiBaseOptions(): ReadApiBaseOptions {
  return {
    getEnvApiBase: () => {
      const v = import.meta.env.VITE_API_BASE
      return typeof v === 'string' ? v : undefined
    },
    devVitePorts: ['5173', '4173']
  }
}

export function defaultApiBase(): string {
  return readApiBaseShared(webApiBaseOptions())
}

export function readApiBase(): string {
  return defaultApiBase()
}

export function writeApiBase(_value: string): void {
  try {
    localStorage.removeItem(LS_API_BASE)
  } catch {
    /* ignore */
  }
}

export function readAppOrigin(): string {
  return readAppOriginShared(webApiBaseOptions())
}
